<template>
  <v-card class="mt-3" :loading="loading">
    <v-card-text>
      <v-row>
        <v-col lg="6" sm="12">
          <v-text-field
            label="brand name"
            v-model="brandName"
            append-outer-icon="save"
            @click:append-outer="save('brandName', brandName)"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="6" sm="12">
          <v-text-field
            label="default locale"
            v-model="defaultLocale"
            append-outer-icon="save"
            @click:append-outer="save('defaultLocale', defaultLocale)"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="6" sm="12">
          <v-text-field
            label="theme primary color hex"
            v-model="themePrimaryColor"
            append-outer-icon="save"
            @click:append-outer="save('themePrimaryColor', themePrimaryColor)"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="6" sm="12">
          <v-textarea
            rows="1"
            auto-grow
            :value="loginInfo | translate"
            label="login information"
            @click="openTranslationDialog('loginInfo', loginInfo)"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="6" sm="12">
          <v-text-field
            label="risk analysis external reference link"
            v-model="riskAnalysisExternalReferenceLink"
            append-outer-icon="save"
            @click:append-outer="
              save(
                'riskAnalysisExternalReferenceLink',
                riskAnalysisExternalReferenceLink
              )
            "
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-checkbox
            v-model="isSupportDialogEnabled"
            label="is support dialog enabled"
            @change="
              save('isSupportDialogEnabled', isSupportDialogEnabled.toString())
            "
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-checkbox
            v-model="instructionsAutoConfirmIfNoManager"
            label="instruction will be automatically confirmed if employee does not have manager"
            @change="
              save(
                'instructionsAutoConfirmIfNoManager',
                instructionsAutoConfirmIfNoManager.toString()
              )
            "
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-checkbox
            v-model="isRiskAnalysisSigningEnabled"
            label="enable signing of risk analysis reading"
            @change="
              save(
                'isRiskAnalysisSigningEnabled',
                isRiskAnalysisSigningEnabled.toString()
              )
            "
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="6" sm="12">
          <v-file-input
            label="change app logo"
            accept=".svg"
            @change="uploadAppLogo"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions v-if="appSettings">
      <div>last change: {{ appSettings.updatedAt | dateTime }}</div>
    </v-card-actions>
    <upsert-translation
      v-if="translationDialog"
      :dialogTitle="translationDialog.dialogTitle"
      :id="translationDialog.id"
      :translation="translationDialog.translation"
      :show="translationDialog.show"
      :loading="loading || this.$apollo.loading"
      @hide="translationDialog = null"
      @add="save(translationDialog.id, JSON.stringify($event))"
    />
  </v-card>
</template>

<script>
import AppSettingsQuery from "@/graphql/queries/appSettings/AppSettings.gql";
import ChangeSettingsMutation from "@/graphql/mutation/appSettings/ChangeAppSettings.gql";
import UploadAppLogoMutation from "@/graphql/mutation/appSettings/UploadAppLogo.gql";

import UpsertTranslation from "@/components/management/component/UpsertTranslation.vue";

export default {
  components: {
    UpsertTranslation,
  },
  data() {
    return {
      loading: false,
      brandName: "",
      defaultLocale: "",
      themePrimaryColor: "",
      isSupportDialogEnabled: false,
      instructionsAutoConfirmIfNoManager: false,
      isRiskAnalysisSigningEnabled: false,
      riskAnalysisExternalReferenceLink: "",
      loginInfo: "",
      translationDialog: null,
    };
  },
  methods: {
    openTranslationDialog(id, translation) {
      this.translationDialog = {
        show: true,
        translation,
        id,
        allTranslations: [],
        dialogTitle: "Change login instructions",
      };
    },
    save(key, value) {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ChangeSettingsMutation,
          variables: {
            key,
            value,
          },
        })
        .then(() => {
          window.location.reload(); // will init translationDialog to null
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            text: err,
            color: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadAppLogo(file) {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: UploadAppLogoMutation,
          variables: {
            file,
          },
        })
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            text: err,
            color: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  apollo: {
    appSettings: {
      query: AppSettingsQuery,
      update(data) {
        this.brandName = data.appSettings.brandName;
        this.themePrimaryColor = data.appSettings.themePrimaryColor;
        this.defaultLocale = data.appSettings.defaultLocale;
        this.isSupportDialogEnabled = data.appSettings.isSupportDialogEnabled;
        this.instructionsAutoConfirmIfNoManager =
          data.appSettings.instructionsAutoConfirmIfNoManager;
        this.isRiskAnalysisSigningEnabled =
          data.appSettings.isRiskAnalysisSigningEnabled;
        this.riskAnalysisExternalReferenceLink =
          data.appSettings.riskAnalysisExternalReferenceLink;
        this.loginInfo = data.appSettings.loginInfo;

        return data.appSettings;
      },
    },
  },
};
</script>
